import type { ReactElement } from 'react'

import { ForecastTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
// import { AnotationList } from '@/components/layouts/Ir/AnotationList'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const ForecastPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-financial-forecast.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-financial-forecast.js')

  /* const anotationlist: string[] = [
    '2022年6月期（実績）及び2023年6月期第2四半期累計期間（実績）の1株当たり当期（四半期）純利益は期中平均発行済株式数により算出しております。',
    '2023年6月期（予想）の1株当たり当期（四半期）純利益は公募予定株式数（23,800,000株）を含めた予定期中平均発行済株式数により算出し、オーバーアロットメントによる売出しに関連する第三者割当増資分（最大3,848,300株）は考慮しておりません。',
    '2023年1月31日付で普通株式1株につき200株の割合で株式分割を行っておりますが、2022年6月期の期首に当該株式分割が行われたと仮定し、1株当たり当期（四半期）純利益を算出しています。',
  ] */

  return (
    <Layout>
      <SectionTitle
        titleText="Consolidated Forecast"
        subTitleText="連結業績予想"
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 30 }} />
      <ForecastTable />
      <Spacer h={{ sp: 50, pc: 80 }} />
      {/* <AnotationList listItem={anotationlist} /> */}
    </Layout>
  )
}

ForecastPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '業績・財務情報', path: '/ir/financial/' },
    { name: '連結業績予想', path: '' },
  ]

  return (
    <>
      <Head
        title="連結業績予想"
        description="トライアルホールディングスグループの連結業績予想について掲載しています。"
        ogp={{ url: 'ir/financial/forecast' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
